module.exports = __webpack_public_path__ + "img/evolis.7c60b9f3.png";